import type {
  AssetDuplicateFormProps,
  AssetDuplicateFormValues,
} from "./asset-duplicate-form.type";
import type { AssetDuplicateVariables, AssetEntity } from "@/entities/asset";

import { useModelDuplicateForm } from "@/modules/model-duplicate";

export const useAssetDuplicateForm = ({ asset }: AssetDuplicateFormProps) => {
  return useModelDuplicateForm<
    AssetEntity,
    AssetDuplicateFormValues,
    AssetDuplicateVariables,
    AssetEntity
  >({
    modelKey: "asset",
    item: asset,
    valuesToVariables: (values) => ({ name: values.name }),
    validationNames: ["name"],
  });
};
